"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyleWrapper = _styledComponents.default.div`

ul{

    background-color: #054894;
    box-shadow: 1px 1px 8px #c7c7c7;
    border-radius: 10px;
    padding: 20px 20px;
    color: #fff;

}

p{
    // color:grey;
    margin-bottom:0.5rem;
}

h2{
    // color: #164686;
    margin-bottom:20px;
}

h4{
    // color: #164686;
}



`;
const TableWrapper = _styledComponents.default.div`

.table-bordered thead td, .table-bordered thead th {
min-width: 100px !important;
vertical-align: top !important;
}
th {
   background: #1e91ce;
   font-size: 15px;
   color: #fff;
   font-weight: 500;
   border: 1px solid white;
   border-top: 0px !important;
   padding: .60rem;
 }
  td {
      padding: .75rem;
    font-size: 13px;
    background: #ececec;
    vertical-align: middle;
 }
.table-responsive > .table-bordered {
  border: 0;
  font-size: 15px;
}
.table-responsive{
    overflow-x:none;
}
@media(max-width:768px){
    .table-bordered thead td, .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      }
      .table-bordered > thead > tr > th:first-child{
        width: auto !important;
      }
      .table-responsive{
          overflow-x: auto;
      }
  }
`;
const DownPayment = _ref => {
  let {
    location
  } = _ref;
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Mortgage Process"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(StyleWrapper, null, /*#__PURE__*/_react.default.createElement("p", null, "At Sun West Mortgage, we want to educate our clients on the mortgage process in as clear and efficient way as possible. To prevent leaving any of our clients in the dark, we created a detailed list to explain how the mortgage loan process works with LowRates."), /*#__PURE__*/_react.default.createElement("h4", null, "1. Start Your Application"), /*#__PURE__*/_react.default.createElement("p", null, "Our team offers several ways to apply for a new home loan. Use our online application to send in your request or contact our office via phone or email. We\u2019ll match you up with one of our team members who will get you started on the mortgage loan process. Prepare small details like your mortgage loan goals, household income, and total assets to share with our team and we\u2019ll prepare your options."), /*#__PURE__*/_react.default.createElement("h4", null, "2. Review Your Options with a Member of Our Team"), /*#__PURE__*/_react.default.createElement("p", null, "Once your application is complete, we\u2019ll take a look at your family\u2019s financial situation and home loan needs and pair you with a list of home loans that fits the cost, rate, and benefits you\u2019ll need."), /*#__PURE__*/_react.default.createElement("h4", null, "3. Confirm Your Information"), /*#__PURE__*/_react.default.createElement("p", null, "A member of our team will review your financial information and confirm that everything looks good. Once everything is confirmed, we will move forward with the application."), /*#__PURE__*/_react.default.createElement("h4", null, "4. Close on Your New Loan"), /*#__PURE__*/_react.default.createElement("p", null, "Once your application is accepted, you are ready to close your loan. Whether you\u2019re ready that same day or need extra time, our loan officers will always be available to you whenever you choose to close on your new loan."), /*#__PURE__*/_react.default.createElement("h4", null, "5. Continue Working with Our Team Throughout the Lifetime of Your Loan"), /*#__PURE__*/_react.default.createElement("p", null, "After you close on your loan, you\u2019ll have full access to our team and resources throughout the lifespan of your loan, like easy access to your loan information and paperwork as well as mortgage advice from our officers. If your financial situation ever changes, feel free to update your payment schedule to better accommodate your new finances. Our team is proud to offer continued service to our clients, from their first loan application to the very last mortgage payment."))));
};
var _default = exports.default = DownPayment;